import config from 'config';
import axios from 'helpers/axios';

const sendFeedbackRequest = (data) => {
  const formData = new FormData();
  formData.append('feedback_option', data.feedback_option);
  formData.append('feedback_text', data.feedback_text);
  formData.append('feedback_url', data.feedback_url);
  return axios({
    method: 'post',
    url: `${config.apiUrl}/feedback`,
    data: formData,
  });
};

const isFeedbackGivenRequest = () =>
  axios({
    method: 'get',
    url: `${config.apiUrl}/is-feedback-given`,
  });

export { isFeedbackGivenRequest, sendFeedbackRequest };
